import { render, staticRenderFns } from "./MainCallStatistics.vue?vue&type=template&id=422d0700&scoped=true&"
import script from "./MainCallStatistics.vue?vue&type=script&lang=js&"
export * from "./MainCallStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MainCallStatistics.vue?vue&type=style&index=0&id=422d0700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d0700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422d0700')) {
      api.createRecord('422d0700', component.options)
    } else {
      api.reload('422d0700', component.options)
    }
    module.hot.accept("./MainCallStatistics.vue?vue&type=template&id=422d0700&scoped=true&", function () {
      api.rerender('422d0700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/main-call/MainCallStatistics.vue"
export default component.exports